import { useState } from "react";
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { CloseOutlined } from "@ant-design/icons";
import { useAuth } from "../../contexts/AuthContext";

import logo from "../../img/logo.png";
import "../../style/MobileMenu.css";
import "../../App.css";
import "../../style/Home.css";

export default function MobileMenu({ menu, onOpenAuth }) {
  const [open, setOpen] = useState(false);
  const { currentUser, signout , currentRestaurant, userProfile} = useAuth();
  const navigate = useNavigate();
const { id } = useParams();
const location = useLocation();



const handleLogoClick = () => {
  const restaurantId =
    id ||
    currentRestaurant?.id ||
    location.pathname.match(/\/shop\/([^/]+)/)?.[1];

  if (restaurantId) {
    navigate(`/shop/${restaurantId}/menu`);
    setOpen(false)
    return;
  }

  navigate("/");
  setOpen(false)
};

  const closeMenu = () => setOpen(false);

  let menuItems = [];

  if (menu) {
    if (currentUser) {
      menuItems = [
        { label: "Mes commandes", to: "/orders", type: "link" },
        { label: "Paramètres", to: "/settings", type: "link" },

        userProfile?.role === "customer"
       ? { label: "Créer ma boutique", to: "/", type: "link" } 
        : { label: "Mon espace pro", to: "/dashboard", type: "link" },

        {
          label: "Se déconnecter",
          onClick: () => {
            signout();
            closeMenu();
          },
          type: "button",
        },
      ];
    } else {
      menuItems = [
        {
          label: "Se connecter",
          onClick: () => {
            closeMenu();
            onOpenAuth?.();
          },
          type: "button",
        },
        { label: "Créer ma boutique", to: "/", type: "link" } 
      ];
    }
  } else {
    menuItems = [
      currentUser
        ? { label: "Dashboard", to: "/dashboard", type: "link" }
        : { label: "Se connecter", to: "/login", type: "link" },
      { label: "Formation gratuite", href: "https://docs.google.com/document/d/1eB0u-7BCbwoLnBIG34E6L39aMfgy3mzkRs6rrw4-ku4/edit?tab=t.0", type: "external" },
      { label: "Contact", href: "mailto:contact@fastlineapp.com", type: "external" },
      { label: "Mentions légales", to: "/legal-notice", type: "link" },
    ];

    if (currentUser) {
      menuItems.push({
        label: "Se déconnecter",
        onClick: () => {
          signout();
          closeMenu();
        },
        type: "button",
      });
    }
  }

  return (
    <>
      <button
        className="mobile-menu-toggle"
        aria-label="Open menu"
        onClick={() => setOpen(true)}
      >
        ☰
      </button>

      <nav className={`mobile-menu-overlay ${open ? "is-open" : ""}`} role="menu">
        <div className="header mobile-menu-container">
          <img
            src={logo}
            alt="Fastline"
            className="logo mobile-menu-logo"
            onClick={handleLogoClick}
          />
          <CloseOutlined
            className="mobile-menu-close"
            aria-label="Close menu"
            onClick={closeMenu}
          />
        </div>

        <ul className="mobile-menu__list">
          {menuItems.map(({ label, to, href, onClick, type }) => (
            <li key={label} className="mobile-menu__item" role="none">
              {type === "link" && (
                <Link
                  to={to}
                  className="mobile-menu__link"
                  role="menuitem"
                  onClick={closeMenu}
                >
                  {label}
                </Link>
              )}

              {type === "external" && (
                <a
                  href={href}
                  className="mobile-menu__link"
                  role="menuitem"
                  onClick={closeMenu}
                >
                  {label}
                </a>
              )}

              {type === "button" && (
                <button
                  className="mobile-menu__link mobile-menu__button"
                  role="menuitem"
                  onClick={onClick}
                >
                  {label}
                </button>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}